import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../../consts/api";

export const useActivateSmartReaderCellular = () => {
  const res = useMutation((dto) =>
    http.post(HTTP_ENDPOINTS.posCardReader.activateSmartReaderCellular(), dto),
  );
  return res;
};
